import { createContext, useContext } from "react";
import type { RefObject } from "react";

import type { ScrollAreaFade } from "@frontend/components/atoms/ScrollArea";

import type { ListSize, ListVirtualizer } from "./List.types";

export type ListContextValue = {
  size: ListSize;
  separators: boolean;
  fade: ScrollAreaFade;
  selectable: boolean;
  selectedValue: string | null;
  selectValue: (value: string) => void;
  viewportRef: RefObject<HTMLDivElement | null>;
  scrollElement: HTMLDivElement | null;
  virtualizerRef: RefObject<ListVirtualizer | null>;
};

export const ListContext = createContext<ListContextValue | null>(null);

export function useListContext(): ListContextValue {
  const context = useContext(ListContext);

  if (!context) {
    throw new Error("List parts must be rendered inside a <List>.");
  }

  return context;
}
